import lodash from 'lodash';
import { isPITenureOverlappingWithDelegation } from './predicates';

const PI_ROLE = 'Principal Investigator';

export function verifyNoPITenuresOverlapped(delegations, currentRole, thisTenure, errorCallback) {
    if (currentRole !== PI_ROLE) {
        return;
    }

    const [piStart, piEnd] = thisTenure;

    const allOverlappingPIs = lodash.filter(
        delegations,
        ({ role, startDate, endDate }) =>
            lodash.get(role, 'name') === PI_ROLE &&
            isPITenureOverlappingWithDelegation([startDate, endDate], [piStart, piEnd])
    );

    if (!lodash.isEmpty(allOverlappingPIs)) {
        errorCallback && errorCallback();
    }
}
